const XmarkDefault = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 11.054L18.8561 19.9999L19.7989 19.0476L10.9428 10.1016L20 0.952441L19.0572 6.26983e-05L10 9.1492L0.942805 0L0 0.952378L9.05723 10.1016L0.201111 19.0476L1.14392 20L10 11.054Z"
        fill="#0B2341"
      />
    </svg>
  )
}

export default XmarkDefault
